import { useState } from "react";

import { Button } from "@stacklet/ui";

import { SuspenseDialog } from "app/components/dialogs";
import { useAlertContext } from "app/contexts/AlertContext";
import { useHasScopePermission } from "app/hooks";
import { createSingleFilter } from "app/utils/filters";

import { UpsertUserForm } from "../UpsertUserForm";

export function CreateNonSsoUser() {
  const { alertDispatch } = useAlertContext();
  const hasPermission = useHasScopePermission();
  const hasSystemEditPermission = hasPermission("system", "EDIT");

  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const filterElement = createSingleFilter("sso", "false");

  const onAdded = (message: string) => {
    alertDispatch({
      message,
      severity: "success",
    });
    setAddDialogOpen(false);
  };

  const showDialog = () => {
    setAddDialogOpen(true);
  };

  return (
    <>
      <Button
        isDisabled={!hasSystemEditPermission}
        onPress={showDialog}
        variant="secondary"
      >
        Create User
      </Button>

      <SuspenseDialog
        onClose={() => {
          setAddDialogOpen(false);
        }}
        open={addDialogOpen}
        title="Create New User"
      >
        <UpsertUserForm
          filterElement={filterElement}
          onAdded={(message) => onAdded(message)}
          onCancel={() => {
            setAddDialogOpen(false);
          }}
        />
      </SuspenseDialog>
    </>
  );
}
